var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#436CF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4559 25.5735C31.2892 27.8775 30.4363 29.6912 28.8971 31.0147C27.3676 32.3382 25.348 33 22.8382 33C20.0931 33 17.9314 32.0784 16.3529 30.2353C14.7843 28.3824 14 25.8431 14 22.6176V21.3088C14 19.25 14.3627 17.4363 15.0882 15.8676C15.8137 14.299 16.848 13.098 18.1912 12.2647C19.5441 11.4216 21.1127 11 22.8971 11C25.3676 11 27.3578 11.6618 28.8676 12.9853C30.3775 14.3088 31.25 16.1667 31.4853 18.5588H27.0735C26.9657 17.1765 26.5784 16.1765 25.9118 15.5588C25.2549 14.9314 24.25 14.6176 22.8971 14.6176C21.4265 14.6176 20.3235 15.1471 19.5882 16.2059C18.8627 17.2549 18.4902 18.8873 18.4706 21.1029V22.7206C18.4706 25.0343 18.8186 26.7255 19.5147 27.7941C20.2206 28.8627 21.3284 29.3971 22.8382 29.3971C24.201 29.3971 25.2157 29.0882 25.8824 28.4706C26.5588 27.8431 26.9461 26.8775 27.0441 25.5735H31.4559Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleverIcon);
export default __webpack_public_path__ + "static/media/clever_icon.cafb84f2e4963e6349c3e4684a740a34.svg";
export { ForwardRef as ReactComponent };